<script>
    // ===============================
    // IMPORTS
    // ===============================
    import Download from 'lucide-svelte/icons/download';
    import FileJson from 'lucide-svelte/icons/file-json';
    import FileSpreadsheet from 'lucide-svelte/icons/file-spreadsheet';

    // ===============================
    // COMPONENT PROPS
    // ===============================
    export let options = [];

    // ===============================
    // LOCAL STATE
    // ===============================
    let isOpen = false; // Track whether the dropdown is open or closed

    // ===============================
    // EVENT HANDLERS
    // ===============================
    // Handle clicking an option
    const download = (url) => {
        // Modify this URL to match your application routes
        window.location.href = url;
    };
</script>

<div
    class="download-container"
    role="button"
    aria-haspopup="true"
    aria-expanded={isOpen}
    tabindex="0"
    on:mouseenter={() => (isOpen = true)}
    on:mouseleave={() => (isOpen = false)}
>
    <button class="download-button">
        <Download /> Download
    </button>

    <div class="dropdown {isOpen ? 'open' : ''}" role="menu" aria-labelledby="download-button">
        {#each options as option}
            <div
                class="dropdown-item"
                role="menuitem"
                tabindex="0"
                on:click={() => download(option.link)}
                on:keydown={(event) => (event.key === 'Enter' || event.key === ' ') && download(option.link)}
            >
                {#if option.label == 'JSON'}
                    <FileJson />
                {:else}
                    <FileSpreadsheet />
                {/if}
                {option.label}
            </div>
        {/each}
    </div>
</div>

<style>
    .download-container {
        position: relative;
        display: inline-block;
        margin: var(--spacing0) 0;
    }

    .download-button {
        border: 1px solid #006997;
        border-radius: 4px;
        background-color: #006997;
        color: #fff;
        cursor: pointer;
        font-size: var(--scale-1);
    }

    .dropdown {
        position: absolute;
        z-index: 1000;
        top: 100%;
        left: 0;
        display: none;
        overflow: hidden;
        min-width: 100%;
        border: 1px solid #ccc;
        background-color: #fff;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        box-shadow: 0 2px 8px rgb(0 0 0 / 15%);
    }

    @media (prefers-color-scheme: dark) {
        .dropdown {
            border-color: var(--cool-90);
            background-color: var(--cool-80);
            color: var(--cool-30);
        }
    }

    .dropdown.open {
        display: block;
    }

    .dropdown-item {
        width: 100%;
        box-sizing: border-box;
        padding: 10px 20px;
        cursor: pointer;
        transition: background-color 0.2s;
        white-space: nowrap;
    }

    .dropdown-item:hover {
        background-color: #f1f1f1;
    }

    @media (prefers-color-scheme: dark) {
        .dropdown-item:hover {
            background-color: #06aee0;
            color: #fff;
        }
    }
</style>
